import { FC } from "react";
import { Box } from "@mui/material";
import { useGetPostByUidQuery } from "@/store/api/postApi";
import Post from "@/pages/Home/components/Post";
import CustomLoader from "./UI/CustomLoader/CustomLoader";

const EmbeddedPost: FC<{ uid: string }> = ({ uid }) => {
  const { data: embeddedPost, isLoading } = useGetPostByUidQuery(uid, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <Box
      sx={{
        my: "0.5rem",
        border: "1px solid #F5F5F5",
        borderBottom: "none",
        borderRadius: "16px",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <CustomLoader loading={isLoading} size={32}>
        {embeddedPost && <Post post={embeddedPost} />}
      </CustomLoader>
    </Box>
  );
};

export default EmbeddedPost;
